<div
  fxLayout="column"
  fxLayoutAlign="space-between center"
  fxFill
  class="container-padding"
>
  <div fxFlex="initial">
    <h1 mat-dialog-title>{{ title }}</h1>
  </div>
  <div fxFlex fxLayout="column" fxFill fxLayoutGap="8">
    <div fxFlex fxLayout="row" fxLayoutGap="8">
      <mat-card fxFlex fxLayout="row" fxLayoutGap="8"  fxLayoutAlign="center">
        <div fxFlex="500px" fxLayout="column" fxLayoutGap="8">
          <!-- <app-input
            fxFlex="initial"
            [config]="getFieldConfig('systemActionCategoryType')"
            [typeCes]="typeCes"
            [group]="form"
            (onSelect)="onSelectType($event)"
          ></app-input>
          <app-input
            fxFlex="initial"
            [config]="getFieldConfig('systemActionCategory')"
            (onSelect)="onSelectSystemActionCategory($event)"
            [typeCes]="typeCes"
            [group]="form"
          ></app-input>
          <app-input
            fxFlex="initial"
            [config]="getFieldConfig('systemAction')"
            [typeCes]="typeCes"
            [group]="form"
            (onSelect)="onSelectSystemAction($event)"
          ></app-input> -->
          <app-input
            fxFlex="initial"
            [config]="getFieldConfig('name')"
            [typeCes]="typeCes"
            [group]="form"
          ></app-input>
          <app-input
            fxFlex="initial"
            [config]="getFieldConfig('description')"
            [typeCes]="typeCes"
            [group]="form"
          ></app-input>
        </div>
      </mat-card>
    </div>
    <div fxFlex="initial" fxLayoutAlign="end" fxLayoutGap="8">
      <button
        class="custom-button"
        type="button"
        (click)="back()"
        mat-raised-button
      >
        VOLTAR
      </button>
      <button
        *ngIf="typeCes !== typeCesEnum.SHOW"
        class="custom-button btn-save"
        type="submit"
        variant="contained"
        mat-raised-button
        [disabled]="form.invalid"
        (click)="save()"
      >
        SALVAR
      </button>
      <button
        *ngIf="typeCes === typeCesEnum.SHOW"
        class="custom-button btn-edit"
        type="submit"
        variant="contained"
        mat-raised-button
        (click)="edit()"
      >
        EDITAR
      </button>
    </div>
  </div>
</div>
